import React from "react";
import "./../index.scss";
import { Contact, Footer, toggleState } from "../components";
import { Helmet } from "react-helmet";
import { siteMetadata, getOrganizationJsonLd } from "../siteMetadata";

const pageTitle = `${siteMetadata.name} | ${siteMetadata.tagline}`;
const ogImageUrl = siteMetadata.siteUrl + siteMetadata.ogImageUrl;

export default () => {
  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={siteMetadata.description} />
        <meta name="keywords" content={siteMetadata.keywords} />
        <link rel="canonical" href={siteMetadata.siteUrl} />
        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={siteMetadata.description} />
        <meta property="og:url" content={siteMetadata.siteUrl} />
        <meta property="og:image" content={ogImageUrl} />
        <meta property="og:site_name" content={siteMetadata.name} />
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={siteMetadata.description} />
        <meta name="twitter:image" content={ogImageUrl} />
        {/* JSON-LD structured data for Google */}
        <script type="application/ld+json">
          {JSON.stringify(getOrganizationJsonLd())}
        </script>
      </Helmet>
      <div className="hero is-fullheight is-black has-background-image">
        <div
          className="background-image"
          style={{
            backgroundImage: "url('/images/landing.jpeg')",
            backgroundPosition: "center center",
            backgroundSize: "cover",
            opacity: "0.5",
            backgroundRepeat: "no-repeat",
          }}
        ></div>
        <div className="hero-body">
          <div
            className="container"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* <h2 className="title has-text-centered is-title-text" style={{ fontSize: "8vw" }}>
              SHOWELLI ENTERTAINMENT
            </h2>

            <h3 className="subtitle has-text-centered">Bespoke Performers</h3> */}
            <img
              src="/images/showelli-logo.png"
              alt="Showelli logo"
              style={{ width: "100%", height: "100%" }}
            />
            <button
              className="button is-secondary-200"
              onClick={() => {
                toggleState();
              }}
            >
              Book Now
            </button>
          </div>
        </div>
      </div>
      <div className="section is-black">
        <div className="container">
          <div
            className="content"
            style={{ marginBottom: "6em", marginTop: "6em" }}
          >
            <p className="has-text-centered has-text-white">
              We provide bespoke entertainment tailored to your event, offering
              everything from individual performers to fully curated shows. Our
              work spans private and corporate parties, birthdays, weddings, and
              residency venues, with current residencies at Yiamas and The Royal
              Bell. Our roster includes dancers, aerialists, musicians, singers,
              and freestyle performers, as well as immersive shows with full
              creative direction, choreography, and production. Whether
              you&apos;re looking for a single standout act or a complete
              entertainment experience, we&apos;ll work closely with you to
              bring your vision to life. Get in touch via our contact page and
              we&apos;ll get back to you.
            </p>
          </div>
          <div className="columns is-vcentered is-mobile is-centered is-wrapped">
            <div className="column is-4">
              <img src="/images/mini-gallery-1.PNG" alt="Showelli Show girl" />
            </div>
            <div className="column is-4">
              <img src="/images/mini-gallery-4.jpeg" alt="Limahl" />
            </div>
            <div className="column is-4">
              <img src="/images/mini-gallery-2.PNG" alt="Showelli Show girl" />
            </div>
          </div>
          <div className="has-text-centered mt-6">
            <a
              className="has-text-secondary-200"
              href="https://www.instagram.com/showellientertainment"
            >
              See more on instagram
            </a>
          </div>
        </div>
      </div>
      <Contact />
      <Footer />
    </>
  );
};
